import React, { useState } from "react";
import {
  ChevronDown,
  ChevronRight,
  FilePlus,
  FileEdit,
  Trash2,
  File,
} from "lucide-react";
import "./AgentExecutionPanel.scss";

/**
 * Shows file operations as they happen during agent execution
 * Displays file path with action icons (create, edit, delete)
 */
const FileChangesTimeline = ({ changes, maxVisible = 10 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getActionConfig = (action) => {
    switch (action) {
      case "create":
        return { Icon: FilePlus, className: "create" };
      case "edit":
      case "modify":
        return { Icon: FileEdit, className: "edit" };
      case "delete":
        return { Icon: Trash2, className: "delete" };
      default:
        return { Icon: File, className: "default" };
    }
  };

  const getFileExtension = (path) => {
    const parts = path.split(".");
    return parts.length > 1 ? parts[parts.length - 1] : "";
  };

  const getFileName = (path) => {
    const parts = path.split("/");
    return parts[parts.length - 1];
  };

  const getFilePath = (path) => {
    const parts = path.split("/");
    parts.pop();
    return parts.join("/");
  };

  if (!changes || changes.length === 0) {
    return null;
  }

  const displayChanges = isExpanded ? changes : changes.slice(-maxVisible);
  const hiddenCount = changes.length - maxVisible;

  return (
    <div className="file-changes-timeline">
      <div
        className="changes-header"
        onClick={() => setIsExpanded(!isExpanded)}
        role="button"
        tabIndex={0}
      >
        {isExpanded ? (
          <ChevronDown size={18} className="expand-icon" />
        ) : (
          <ChevronRight size={18} className="expand-icon" />
        )}
        <span className="header-text">
          Files ({changes.length})
        </span>
      </div>

      {(isExpanded || changes.length <= maxVisible) && (
        <div className="changes-list">
          {!isExpanded && hiddenCount > 0 && (
            <div className="more-changes" onClick={() => setIsExpanded(true)}>
              + {hiddenCount} more changes
            </div>
          )}
          {displayChanges.map((change, index) => {
            const actionConfig = getActionConfig(change.action);
            const { Icon } = actionConfig;
            const extension = getFileExtension(change.path);
            const fileName = getFileName(change.path);
            const filePath = getFilePath(change.path);

            return (
              <div key={index} className={`change-item ${actionConfig.className}`}>
                <Icon size={16} className="action-icon" />
                <div className="file-info">
                  <span className={`file-name ext-${extension}`}>{fileName}</span>
                  {filePath && <span className="file-path">{filePath}/</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FileChangesTimeline;
